import { Fragment, useState, useEffect } from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import IconButton from '@mui/material/IconButton';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import Popover from '@mui/material/Popover';
import dayjs from 'dayjs';
import pfc from '../../../pfc/functions'

import { setActualTime } from "../../../lib/dates.js";
import { FormContainer, TextFieldElement, SelectElement, MultiSelectElement, AutocompleteElement, DatePickerElement } from 'react-hook-form-mui';

import {
  Alert, Button, Box, Avatar, List, ListItem, ListItemAvatar, ListItemText, DialogTitle, Dialog, Typography, DialogContent,
  TextField, FormControl, OutlinedInput, FormHelperText, InputLabel, FilledInput, Grid, DialogContentText, DialogActions,  Snackbar,
} from '@mui/material';
import { selectCurrentUser } from "../../../redux/reducers/authSlice"
import {
  DataGridPro, GridToolbarQuickFilter, gridNumberComparator, GridToolbar, GridActionsCellItem, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton,
  GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton
} from '@mui/x-data-grid-pro';
import theme from '../../../theme';
import { getThemeProps } from '@mui/system';
import { getPagosData, addPago, editPago, deletePago, cleanError, cleanMessage, resetData  } from "./pagosSlice.js";
import { useSelector, useDispatch } from 'react-redux';
const zfill = (number, width) => {
  var numberOutput = Math.abs(number); /* Valor absoluto del número */
  var length = number.toString().length; /* Largo del número */
  var zero = "0"; /* String de cero */

  if (width <= length) {
    if (number < 0) {
      return ("-" + numberOutput.toString());
    } else {
      return numberOutput.toString();
    }
  } else {
    if (number < 0) {
      return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
    } else {
      return ((zero.repeat(width - length)) + numberOutput.toString());
    }
  }
};
function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
};
function getFecha(date) {
  date = new Date(parseInt(date)).toLocaleString().split(",");
  date = date[0].split("/");

  let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
  let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
  let y = date[2];
  return d + '/' + m + '/' + y
};
const fechaSortComparator = (v1, v2, param1, param2) => {
  function getFechaNumero(date) {
    date = date.split('/')
    let d = date[0]
    let m = date[1]
    let y = date[2];
    var fullDate = y + m + d;
    return parseInt(fullDate);
  }
  let fecha1 = getFechaNumero(param1.value)
  let fecha2 = getFechaNumero(param2.value)
  const ComparatorResult = gridNumberComparator(
    fecha1,
    fecha2,
  );
  if (ComparatorResult !== 0) {
    return ComparatorResult;
  }
  return gridNumberComparator(v1.name, v2.name, param1, param2);
};
const importeSortComparator = (v1, v2, param1, param2) => {
  function getImporteNumero(importe) {
    importe = importe.replace('$', '').replace(',', '').replace('.', '')
    return parseInt(importe);
  }
  let number1 = getImporteNumero(param1.value)
  let number2 = getImporteNumero(param2.value)
  const ComparatorResult = gridNumberComparator(
    number1,
    number2,
  );
  if (ComparatorResult !== 0) {
    return ComparatorResult;
  }
  return gridNumberComparator(v1.name, v2.name, param1, param2);
};
const getMedioPago = (medioId) => {
  if (medioId === 1) {
    return 'Manual'
  }
  if (medioId === 2) {
    return 'Cuenta Recaudadora'
  }
  if (medioId === 3) {
    return 'Debito Directo'
  }
  if (medioId === 4) {
    return 'GetNet'
  }
  if (medioId === 5) {
    return 'Sistema'
  }
}
const getDescripcionPago = (des) => {
  let instrumento = ''
  let estado = ''
  des = des.split('#')
  let acreditacion = des[1]
  des = des[0]
  switch (true) {
    case des.startsWith('Ajuste Sistema'):
      instrumento = 'Ajuste Sistema';
      break;
    case des.startsWith('EFECTIVO'):
      instrumento = 'Efectivo Pesos';
      break;
    case des.startsWith('CH24SRIO') || des.startsWith('ECH24SRI'):
      instrumento = 'Cheque 24/Santander';
      break;
    case des.startsWith('CH48SRIO') || des.startsWith('ECH48SRI'):
      instrumento = 'Cheque 48/Santander';
      break;
    case des.startsWith('CH72SRIO') || des.startsWith('ECH72SRI'):
      instrumento = 'Cheque 72/Santander';
      break;
    case des.startsWith('CH48CC') || des.startsWith('ECH48CC'):
      instrumento = 'Cheque 48 CC';
      break;
    case des.startsWith('CPD') || des.startsWith('ECPD'):
      instrumento = 'Cheque Pago Diferido';
      break;
    case des.startsWith('DBCTA'):
      instrumento = 'Débito en cuenta';
      break;
    case des.startsWith('CH24CL') || des.startsWith('ECH24CL'):
      instrumento = 'Cheque 48 Cámara local';
      break;
    case des.startsWith('SNP$'):
      instrumento = 'Débito en cuenta SNP $';
      break;
    case des.startsWith('EFERAPI'):
      instrumento = 'Efectivo Rapipago';
      break;
    case des.startsWith('INTERPGO'):
      instrumento = 'Interpago (Pagos Interbanking)';
      break;
    case des.startsWith('VCTRUNC') || des.startsWith('EVCTRUNC'):
      instrumento = 'Valores al Cobro Truncados';
      break;
    case des.startsWith('CL48TRUN') || des.startsWith('ECL48TRU'):
      instrumento = 'Cámara local 48 horas Truncado';
      break;
    case des.startsWith('TR-SNP'):
      instrumento = 'Transferencias CBU Recaudadora - SNP';
      break;
    case des.startsWith('TR-ANET'):
      instrumento = 'Transferencias CBU Recaudadora - Interbanking';
      break;
    case des.startsWith('NOFINANC'):
      instrumento = 'Pago no financiero';
      break;
    case des.startsWith('TBANELCO'):
      instrumento = 'Transferencias CBU Recaudadora – BANELCO';
      break;
    case des.startsWith('CREDIARS'):
      instrumento = 'Billetera Virtual';
      break;
    case des.startsWith('DEBIN'):
      instrumento = 'DEBIN Pesos';
      break;
    case des.startsWith('EFECU$S'):
      instrumento = 'Efectivo Dólares';
      break;
    case des.startsWith('DBCTAU$S'):
      instrumento = 'Débito en cuenta Dólares';
      break;
    case des.startsWith('DEBINU$S'):
      instrumento = 'DEBIN Dolares';
      break;
    default:
      // Manejar el caso por defecto si no se cumple ninguna condición
      break;
  }
  switch (acreditacion) {
    case ' ':
    case 'A':
    case 'B':
    case 'E':
      estado = 'Acreditado';
      break;
    case 'S':
      estado = 'Acreditado';
      break;
    case 'R':
      estado = 'Rechazado';
      break;
    case 'D':
      estado = 'Diferido';
      break;
    case 'P':
      if (des.startsWith('EFERAPI')) {
        estado = 'Acredita a las 48HS.';
      }
      if (des.startsWith('INTERPGO')) {
        estado = 'Pendiente (no vino información de interbanking)';
      }
      break;
    case 'T':
      estado = 'Rescatado';
      break;
    case 'C':
      estado = 'Cesionado desde la custodia';
      break;
    case 'Y':
      estado = 'Fallas técnicas o cheque posdatado';
      break;
    case 'V':
      estado = 'Faltante';
      break;
    case 'X':
      estado = 'Rechazo con posible redepósito';
      break;
    case 'U':
      estado = 'Rechazo con redepósito';
      break;
    case 'Z':
      estado = 'Cheque no redepositado';
      break;
    default:
      // Manejar el caso por defecto si no se cumple ninguna condición
      break;
  }
  return instrumento + ' - ' + estado

}

const PagosCat = () => {
  const currentUser = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const {fetching,  message, error } = useSelector(state => state.pagos);
  const { pagos, personas, clasesContratos, titularidades, contratos } = useSelector(state => state.pagos.data);
  useEffect(() => { dispatch(getPagosData()) }, []);
  const Header = (props) => {
    return (<Fragment>
      <Typography variant="h5" component="div" sx={{ minWidth: 275, margin: '10px' }}>{'Pagos'}</Typography>
      {fetching > 0 && <p>Cargando</p>}
    </Fragment>);
  };
  const Notification = (props) => {
    const [showNotification, setShowNotification] = useState(true);
    const onClose = () => setShowNotification(false);
    return (<>{error || message ? 
    <Snackbar fullWidth anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={showNotification} autoHideDuration={3000} onClose={onClose} >
      <Alert severity={error ? 'error' : 'success'} variant={'standard'} fullWidth>
       <Typography fontWeight={'bold'} children={error ? error : message} />
      </Alert>
    </Snackbar>: null }</>)
  }
  const PagosTable = (props) => {
    const moneyFormat = (v) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(parseFloat(v).toFixed(2)).replace('ARS', '');
    const [showEditPagoForm, setShowEditPagoForm] = useState(false);
    const [showDeletePagoForm, setShowDeletePagoForm] = useState(false);
    let rows = (pagos || [])?.map(p => ({
      ...p,
      montoNominal: (p.montoNominal / 100).toFixed(2)
    })).sort((a, b) => b.pagoId - a.pagoId);
    const GridAction = (props) => {
      const [anchorEl, setAnchorEl] = useState(null);

      const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget)
      };

      const handlePopoverClose = () => {
        setAnchorEl(null)
      };
      const { label, key, Icon } = props;
      const open = Boolean(anchorEl);
      return (
        <Fragment key={key + label}>
          <Icon aria-owns={open ? label : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}> </Icon>
          <Popover
            id={label}
            sx={{
              pointerEvents: 'none',
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{label}</Typography>
          </Popover>
        </Fragment>
      )
    };
    const columns = [
      { field: 'pagoId', headerName: 'ID', width: 70 },
      { field: 'fecha', headerName: 'Fecha', width: 100, valueGetter: v => getFecha(v.row.fecha), sortComparator: fechaSortComparator },
      { field: 'fechaValor', headerName: 'Fecha Valor', width: 100, valueGetter: v => getFecha(v.row.fechaValor), sortComparator: fechaSortComparator },
      { field: 'montoNominal', headerName: 'Monto', width: 100, renderCell: v => '$' + moneyFormat(v.row.montoNominal) },
      { field: 'contratoId', headerName: 'ID Contrato', width: 100, renderCell: v => zfill(v.row.contratoId, 6) },
      { field: 'medioDePagoId', headerName: 'Medio', width: 200, valueGetter: v => getMedioPago(v.row.medioDePagoId) },
      { field: 'refId', headerName: 'Ref ID', width: 100 },
      { field: 'descripcion', headerName: 'Descripción', width: 200, valueGetter: v => typeof v.row.descripcion === 'string' ? getDescripcionPago(v.row.descripcion) : '' },
      {
        field: 'actions', headerName: 'Acciones', width: 150, type: 'actions', renderCell: v =>
          <>
            <GridActionsCellItem key={v.row.pagoId + '-editarGridAction'} disabled={currentUser?.permisos?.includes("createCuponPago") ? false : true} color={'info'} onClick={() => setShowEditPagoForm(v.row)} icon={<GridAction label={'Editar'} key={v.row.pagoId} Icon={EditIcon} />} />
            <GridActionsCellItem key={v.row.pagoId + '-borrarGridAction'} disabled={currentUser?.permisos?.includes("createCuponPago") ? false : true} color={'danger'} onClick={() => setShowDeletePagoForm(v.row)} icon={<GridAction label={'Eliminar'} Icon={DeleteIcon} />} />
          </>
      }
    ];
    const EditPagoForm = (props) => {
      const pago = showEditPagoForm
      const defaultValues = {
        ...pago,
        montoNominal: parseFloat(pago.montoNominal),
        fecha: parseInt(pago.fecha),
        fechaValor: parseInt(pago.fechaValor)
      }

      const onSubmit = (newPago) => {
        let aux = { ...newPago };
        aux.contratoId = aux.contratoId.value ? aux.contratoId.value : pago.contratoId; //A: el valor del select es un objeto, no el id del contrato
        aux.fecha = aux.fecha.valueOf(); //A: el valor del datepicker es un objeto, no un timestamp
        aux.fecha = setActualTime(aux.fecha); //A: seteamos la hora actual
        aux.montoNominal = parseInt((aux.montoNominal * 100).toFixed(0)); //A: convertimos pesos a centavos
        aux.fechaValor = aux.fechaValor.valueOf(); //A: el valor del datepicker es un objeto, no un timestamp
        aux.fechaValor = setActualTime(aux.fechaValor);
        dispatch(editPago(aux)).unwrap().then(resetData()).catch(console.log);       
      }

      const getOption = (x) => {
        const claseContrato = clasesContratos?.find(cc => cc.claseContratoId === x.claseContratoId);
        const persona = (personas || [])?.find(p => p.personaId === (titularidades || []).find(t => t.contratoId === x.contratoId)?.personaId);
        return { label: x?.contratoId + ' -- ' + claseContrato?.codigo + ' -- ' + persona?.apellido + ' ' + persona?.nombre, value: x?.contratoId }
      }
      const options = (contratos || []).reduce((p, x) => [...p, getOption(x)], []);

      return (
        <Dialog onClose={() => setShowEditPagoForm(false)} open={showEditPagoForm}>
          <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Edicion Pago ID {pago?.pagoId}:</DialogTitle>
          <FormContainer defaultValues={defaultValues} onSuccess={onSubmit} >
            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ 'padding-top': '20px' }}> {/*el padding-top soluciona un problema con el label: se oculta cuando el usuario hace clicl. esto solo pasa para la primera fila de inputs*/}
                  <AutocompleteElement name='contratoId' label='Contrato' options={options} sx={{ width: '100%', padding: '10px' }} required />
                </Grid>
                <Grid item xs={6} style={{ 'padding-top': '20px' }}> {/*el padding-top soluciona un problema con el label: se oculta cuando el usuario hace clicl. esto solo pasa para la primera fila de inputs*/}
                  <TextFieldElement type={'number'}sx={{ width: '100%' }} required label='Monto' name='montoNominal' />
                </Grid>
                <Grid item xs={6} >
                  <TextFieldElement sx={{ width: '100%' }} required disabled label='Medio de pago' name='medioDePagoId' />
                </Grid>
                <Grid item xs={12} >
                  <TextFieldElement sx={{ width: '100%' }} required label='Id de Referencia' name='refId' />
                </Grid>
                <Grid item xs={6} >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePickerElement label="Fecha" inputFormat="DD/MM/YYYY" name="fecha" required />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={6} >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePickerElement label="Fecha Valor" inputFormat="DD/MM/YYYY" name="fechaValor" required />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" disabled={fetching > 0} onClick={() => setShowEditPagoForm(false)} sx={{ marginTop: '10px', fontWeight: "bold" }}>{"Cancelar"}</Button>
              <Button variant="contained" disabled={fetching > 0} type={'submit'} sx={{ marginRight: '5px', marginTop: '10px', fontWeight: "bold", color: "white" }}>{"Aceptar"}</Button>
            </DialogActions>
          </FormContainer>
        </Dialog>
      )
    };
    const DelPagoForm = (props) => {
      const onSubmit = (pagoId) => {
        dispatch(deletePago(showDeletePagoForm.pagoId)).unwrap().then(console.log).catch(console.log);
        setShowDeletePagoForm(false);
      }
      return (
        <Dialog
          open={showDeletePagoForm}
          onClose={() => setShowDeletePagoForm(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Eliminar Pago (manual):</DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              {`Esta seguro de que quiere eliminar el pago ID: ${showDeletePagoForm.pagoId}?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" sx={{ fontWeight: "bold" }} onClick={() => setShowDeletePagoForm(false)}>Cancelar</Button>
            <Button variant="contained" sx={{ fontWeight: "bold", color: "white" }} onClick={onSubmit} autoFocus>Confirmar</Button>
          </DialogActions>
        </Dialog>
      )
    };
    const BtnBar = (props) => {
      const [showNewPagoForm, setShowNewPagoForm] = useState(false);

      const NewPagoForm = (props) => {

        const defaultValues = {
          montoNominal: 0,
          contratoId: null,
          medioDePagoId: 1,
          refId: null,
          fecha: Date.now(),
          fechaValor: Date.now(),
        }

        const onSubmit = (newPago) => {
          let aux = { ...newPago };
         
          aux.contratoId = aux.contratoId.value; //A: el valor del select es un objeto, no el id del contrato
          aux.fecha = aux.fecha.valueOf(); //A: el valor del datepicker es un objeto, no un timestamp
          aux.fecha = setActualTime(aux.fecha); //A: seteamos la hora actual
          aux.fechaValor = aux.fechaValor.valueOf(); //A: el valor del datepicker es un objeto, no un timestamp
          aux.fechaValor = setActualTime(aux.fechaValor);
          aux.montoNominal = parseInt((aux.montoNominal * 100).toFixed(0)); //A: convertimos pesos a centavos
          dispatch(addPago(aux)).unwrap().then(console.log).catch(console.log);
        }

        const getOption = (x) => {
          const claseContrato = clasesContratos?.find(cc => parseInt(cc.claseContratoId) === parseInt(x.claseContratoId));
          const persona = (personas || [])?.find(p => p.personaId === (titularidades || []).find(t => t.contratoId === x.contratoId && t.titularPrincipal)?.personaId);
          return { label: x?.contratoId + ' -- ' + claseContrato?.codigo + ' -- ' + persona?.apellido + ' ' + persona?.nombre, value: x?.contratoId }
        }
        const options = (contratos || []).reduce((p, x) => [...p, getOption(x)], []);

        return (
          <Dialog onClose={() => setShowNewPagoForm(false)} open={showNewPagoForm}>
            <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Nuevo Pago (manual):</DialogTitle>
            <FormContainer defaultValues={defaultValues} onSuccess={onSubmit} >
              <DialogContent dividers>
                <Grid container spacing={2}>
                  <Grid item xs={12} style={{ 'padding-top': '20px' }}> {/*el padding-top soluciona un problema con el label: se oculta cuando el usuario hace clicl. esto solo pasa para la primera fila de inputs*/}
                    <AutocompleteElement name='contratoId' label='Contrato' options={options} sx={{ width: '100%', padding: '10px' }} required />
                  </Grid>
                  <Grid item xs={6} style={{ 'padding-top': '20px' }}> {/*el padding-top soluciona un problema con el label: se oculta cuando el usuario hace clicl. esto solo pasa para la primera fila de inputs*/}
                    <TextFieldElement sx={{ width: '100%' }} type='number' required label='Monto' name='montoNominal' />
                  </Grid>
                  <Grid item xs={6} >
                    <TextFieldElement sx={{ width: '100%' }} required disabled label='Medio de pago' name='medioDePagoId' />
                  </Grid>
                  <Grid item xs={12} >
                    <TextFieldElement sx={{ width: '100%' }} required label='Id de Referencia' name='refId' />
                  </Grid>
                  <Grid item xs={6} >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePickerElement label="Fecha" inputFormat="DD/MM/YYYY" name="fecha" required />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6} >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePickerElement label="Fecha Valor" inputFormat="DD/MM/YYYY" name="fechaValor" required />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button variant="outlined" onClick={() => setShowNewPagoForm(false)} sx={{ marginTop: '10px', fontWeight: "bold" }}>{"Cancelar"}</Button>
                <Button variant="contained" type={'submit'} sx={{ marginRight: '5px', marginTop: '10px', fontWeight: "bold", color: "white" }}>{"Aceptar"}</Button>
              </DialogActions>
            </FormContainer>
          </Dialog>
        )
      };

      return (
        <Fragment>
           <Button className="mb-3" variant="contained" color='primary'  sx={{ height: '4vh', width: '15%', fontWeight: 'bold', margin: '0.4em' }} onClick={() => setShowNewPagoForm(true)}>NUEVO<AddIcon/></Button>
          {/* <IconButton className="mb-3" variant="contained" color='primary' onClick={() => setShowNewPagoForm(true)}><AddIcon /></IconButton> */}
          {showNewPagoForm ? <NewPagoForm /> : null}
        </Fragment>)
    };

    return (
      <Fragment>
       
        <Box fullWidth >
          <DataGridPro
            pagination
            sx={{ height: '75vh'}}
            getRowId={r => r.pagoId}
            rows={currentUser?.permisos?.find(p => p.toLowerCase() !== "readPagos") ? rows : []}
            columns={columns}
            components={{
              Toolbar: () => {
                return <Fragment>
                  <GridToolbarContainer>
                    <Grid conteiner
                      rowSpacing={0} sx={{
                        display: "inline-flex",
                        justifyContent: "space-between",
                        alignItems: "strech",
                        width: "100%"
                      }}>
                         {currentUser?.permisos?.includes("createCuponPago") ? <BtnBar></BtnBar> : null}
                      <Grid sx={{ width: "100%", marginLeft: '1em'  }}>
                        <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                        {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                          : ''}
                      </Grid>
                      <GridToolbarQuickFilter />
                    </Grid>
                  </GridToolbarContainer>
                </Fragment>
              }
            }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            loading={fetching > 0}
          />
          {showEditPagoForm ? <EditPagoForm /> : null}
          {showDeletePagoForm ? <DelPagoForm /> : null}
        </Box>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Notification />
      <Header></Header>
      <PagosTable></PagosTable>
    </Fragment>
  )
};

export default PagosCat;